import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "corporate-page" }

import CorporateHeader from '@/components/corporate/CorporateHeader.vue';
import CorporateMainVisual from '@/components/corporate/CorporateMainVisual.vue';
import CorporateRecruit from '@/components/corporate/CorporateRecruit.vue';
import CorporateCompanyInfo from '@/components/corporate/CorporateCompanyInfo.vue';
import CorporateContact from '@/components/corporate/CorporateContact.vue';
import CorporateFooter from '@/components/corporate/CorporateFooter.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CorporateHeader),
    _createVNode(CorporateMainVisual),
    _createVNode(CorporateRecruit),
    _createVNode(CorporateCompanyInfo),
    _createVNode(CorporateContact),
    _createVNode(CorporateFooter)
  ]))
}
}

})